import styled from 'styled-components';

import { Color } from '../../../shared/constants/Colors';
import {
  MediaQuery,
  Shadow,
  Transition,
} from '../../../shared/constants/Styles';

import { CardAppearance } from './Card';

export const StyledCard = styled.div`
  box-sizing: border-box;
  overflow: hidden;
  box-shadow: none;
  transition: ${Transition.ALL_EASE};
  text-decoration: none;
  position: relative;

  ${({ appearance, isFloating, defaultBackground, gradientColor, isStatic }) =>
    appearance === CardAppearance.SIMPLE &&
    `
    height: ${isStatic ? '550' : '490'}px;
    width: 390px;
    border-radius: 30px;
    padding: 15px 15px 30px 15px;
    background-image: ${isFloating ? 'none' : gradientColor};
    box-shadow: ${isFloating ? Shadow.BLUE_ACTIVE : 'none'}; 
    background: ${isFloating ? Color.WHITE : defaultBackground};

    &:hover {
      transform: ${
        isStatic ? 'none' : 'translateY(-5px) scale(1.005) translateZ(0)'
      };
    }

    ${MediaQuery.S_AND_DOWN} {
      padding: 12px;
      border-radius: 15px;
      width: 100%;
      height: auto;
    }
  `};

  ${({ appearance }) =>
    appearance === CardAppearance.VERTICAL &&
    `
    height: 490px;
    width: 390px;
    border-radius: 30px;
    padding: 15px 15px 30px 15px;
    background: transparent;

    &:hover {
      background: ${Color.WHITE};
      transform: translateY(-5px) scale(1.005) translateZ(0);
      box-shadow: ${Shadow.BLUE_ACTIVE};
    }

    ${MediaQuery.S_AND_DOWN} {
      padding: 12px;
      border-radius: 15px;
      width: 100%;
      height: auto;

      &:hover {
        background: transparent;
        transform: none;
        box-shadow: none;
      }
    }
  `};

  ${({ appearance }) =>
    appearance === CardAppearance.HORIZONTAL &&
    `
    height: 120px;
    width: 410px;
    border-radius: 15px;
    background: transparent;
    padding: 10px;

    &:hover {
      background: ${Color.WHITE};
      transform: translateY(-5px) scale(1.005) translateZ(0);
      box-shadow: ${Shadow.BLUE_ACTIVE};
    }

    ${MediaQuery.S_AND_DOWN} {
      width: 100%;
      height: auto;

      &:hover {
        background: transparent;
        transform: none;
        box-shadow: none;
      }
    }
  `};
`;
